import React, { useEffect, useState } from 'react';
import { ShoppingBagIcon, XIcon } from 'lucide-react';
import { purchases } from '../data/purchases';
import { OFFER_ANCHOR } from '../data/constants';
export function PurchaseToast() {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    let timeout: ReturnType<typeof setTimeout>;
    const show = setTimeout(function cycle() {
      setVisible(true);
      timeout = setTimeout(() => {
        setVisible(false);
        setIndex(i => (i + 1) % purchases.length);
        timeout = setTimeout(cycle, 7000);
      }, 6000);
    }, 4000);
    return () => {
      clearTimeout(show);
      clearTimeout(timeout);
    };
  }, [dismissed]);
  if (dismissed || !visible) return null;
  const purchase = purchases[index];
  return <div role="status" aria-live="polite" className="fixed bottom-3 left-3 z-50 max-w-[19rem] animate-toast-in rounded-xl border-[3px] border-gold bg-espresso p-2.5 pr-8 shadow-[0_10px_28px_-8px_rgba(41,23,13,0.7)]" data-id="element-204" data-mp="b43rphrly89z">
      <a href={OFFER_ANCHOR} className="flex items-center gap-2.5" data-id="element-205" data-mp="1z49g3iagkk4m">
        <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-burnt" data-id="element-206" data-mp="236o22b9fc004">
          <ShoppingBagIcon className="h-4 w-4 text-white" strokeWidth={2.5} aria-hidden="true" data-id="element-207" data-mp="286sjc3i5oyre" />
        </span>
        <span className="min-w-0" data-id="element-208" data-mp="1bgt09f4dqhuk">
          <span className="block text-[0.78rem] font-extrabold leading-tight text-cream" data-id="element-209" data-mp="1bhuo6k6huytp">
            {purchase.name} <span className="font-semibold text-gold" data-id="element-210" data-mp="1ffilftvnt3or">just bought this digital book</span>
          </span>
          <span className="block truncate text-[0.68rem] font-medium text-cream/70" data-id="element-211" data-mp="1kelgqmlu7vjj">
            {purchase.location} · a few minutes ago
          </span>
        </span>
      </a>
      <button type="button" onClick={() => setDismissed(true)} aria-label="Close notification" className="absolute right-1.5 top-1.5 rounded p-1 text-cream/60 transition-colors duration-150 ease-out hover:text-cream" data-id="element-212" data-mp="rrhh6x5ik9f5">
        <XIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-213" data-mp="1v3g87e3aflyy" />
      </button>
    </div>;
}